import { useEffect, useState } from "react";
import { ThemeProvider } from "@mui/material/styles";
import Loader from "examples/Loader";
import theme from "assets/theme";
import { useAgencyInfo } from "context/agency";
import { useAppServices } from "hook/services";
import OnboardingWizard from "./index";

function OnboardingGate({ children }) {
  const [agency, Update] = useAgencyInfo();
  const Service = useAppServices();
  const [onboardingSteps, setOnboardingSteps] = useState(null);

  useEffect(() => {
    if (!agency?._id) return undefined;

    let cancelled = false;
    const loadOnboardingSteps = async () => {
      try {
        const { response } = await Service.superadmin.GET();
        if (!cancelled) setOnboardingSteps(response?.data?.onboarding || []);
      } catch (error) {
        console.error("Failed to fetch onboarding steps", error);
        if (!cancelled) setOnboardingSteps([]);
      }
    };

    loadOnboardingSteps();
    return () => {
      cancelled = true;
    };
  }, [agency?._id]);

  if (!agency?._id) return children;

  if (onboardingSteps === null) {
    return (
      <ThemeProvider theme={theme}>
        <Loader />
      </ThemeProvider>
    );
  }

  const steps = onboardingSteps.filter((step) => step?.key);
  const completed = agency?.onboarding || [];
  const blocking = steps.some((step) => !completed.includes(step.key));

  return (
    <ThemeProvider theme={theme}>
      <div style={blocking ? { display: "none" } : undefined}>{children}</div>
      {blocking && <OnboardingWizard steps={steps} agency={agency} Update={Update} />}
    </ThemeProvider>
  );
}

export default OnboardingGate;
